const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize_Bus_RdfSerialize = new (require('@comunica/core').Bus)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-serialize/Bus/RdfSerialize'
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_mediatorRdfSerializeMediatypes = new (require('@comunica/mediator-combine-union').MediatorCombineUnion)({
  'field': 'mediaTypes',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-serialize/^1.0.0/config/config-default.json#mediatorRdfSerializeMediatypes',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize_Bus_RdfSerialize
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_mediatorRdfSerializeHandle = new (require('@comunica/mediator-race').MediatorRace)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-serialize/^1.0.0/config/config-default.json#mediatorRdfSerializeHandle',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize_Bus_RdfSerialize
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_myRdfSerializerN3 = new (require('@comunica/actor-rdf-serialize-n3').ActorRdfSerializeN3)({
  'mediaTypes': {
  'application/trig': '1.0',
  'application/n-quads': '0.7',
  'text/turtle': '0.6',
  'application/n-triples': '0.3',
  'text/n3': '0.2'
},
  'mediaTypeFormats': {
  'application/trig': 'http://www.w3.org/ns/formats/TriG',
  'application/n-quads': 'http://www.w3.org/ns/formats/N-Quads',
  'text/turtle': 'http://www.w3.org/ns/formats/Turtle',
  'application/n-triples': 'http://www.w3.org/ns/formats/N-Triples',
  'text/n3': 'http://www.w3.org/ns/formats/N3'
},
  'priorityScale': '1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-serialize/^1.0.0/config/config-default.json#myRdfSerializerN3',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize_Bus_RdfSerialize
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_myRdfSerializerJsonLd = new (require('@comunica/actor-rdf-serialize-jsonld').ActorRdfSerializeJsonLd)({
  'jsonStringifyIndentSpaces': 2,
  'mediaTypes': {
  'application/ld+json': '1.0'
},
  'mediaTypeFormats': {
  'application/ld+json': 'http://www.w3.org/ns/formats/JSON-LD'
},
  'priorityScale': '9.0E-1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-serialize/^1.0.0/config/config-default.json#myRdfSerializerJsonLd',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize_Bus_RdfSerialize
});
const urn_comunica_my = new (require('./lib/RdfSerializer').RdfSerializer)({
  'mediatorRdfSerializeMediatypes': https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_mediatorRdfSerializeMediatypes,
  'mediatorRdfSerializeHandle': https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_mediatorRdfSerializeHandle,
  'serializers': [
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_myRdfSerializerN3,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_serialize__1_0_0_config_config_default_json_myRdfSerializerJsonLd
]
});
module.exports = urn_comunica_my;

